import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type UpdateOrderPriceData = {
  uuid: string; 
  price: number; 
};

const useUpdateOrderPrice = (
  options?: UseMutationOptions<any, Error, UpdateOrderPriceData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['updateOrderPrice'],
    mutationFn: async (data: UpdateOrderPriceData) => {
      return axiosInstance.put(`/orders/${data.uuid}/price`, { price: data.price }).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Aktualizacja wartości zlecenia...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'update-order-price',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Wartość zlecenia zaktualizowana pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'update-order-price',
      });
      queryClient.invalidateQueries({ queryKey: ['orderDetails'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji wartości zlecenia.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'update-order-price',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateOrderPrice;
